import React from 'react'
import './account-filter.scss'
import { IStaff } from '@/model/types/staff'
import useSelectList from '@/utils/hooks/useSelectList'
import { IUser } from '@/model/types/user'
import { Column, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import classnames from 'classnames'
import Iconfont from '@/components/iconfont/iconfont'
import { accountFilterStore } from './filter-store'
import $msg from '@/utils/message'
import { observer } from 'mobx-react'

interface AccountFilterProps {
    staffs: IStaff[]
    onClose: () => void
}

const AccountFilter: React.FC<AccountFilterProps> = observer(props => {
    const scene = [
        {
            id: 0,
            name: '收银台',
        },
        {
            id: 1,
            name: '微商城',
        },
    ]

    const senceSelectAction = useSelectList<{ id: number; name: string }>(accountFilterStore.scene, 'id')
    const staffSelectAction = useSelectList<{ id: number; user: IUser }>(accountFilterStore.staffIds, 'id')

    const cls = useBemClass('account-filter')

    return (
        <Column
            className={cls('container')}
            style={{
                top: accountFilterStore.filterText ? '272px' : '222px',
            }}
        >
            <Row>
                <div
                    data-color-999
                    data-font-size-14
                    data-margin-right-25
                    style={{
                        flexShrink: 0,
                        marginTop: '26px',
                    }}
                >
                    场景筛选
                </div>
                <Row
                    style={{
                        flexWrap: 'wrap',
                        alignItems: 'center',
                    }}
                >
                    {scene.map(item => (
                        <div
                            className={classnames(cls('tag'), {
                                [cls('tag', 'active')]: senceSelectAction.has(item),
                            })}
                            key={item.id}
                            onClick={() => {
                                senceSelectAction.toggle(item)
                            }}
                        >
                            <div hidden={!senceSelectAction.has(item)} className={cls('tag', 'icon')}>
                                <Iconfont name="iconyixuan" size={14} />
                            </div>
                            <span>{item.name}</span>
                        </div>
                    ))}
                </Row>
            </Row>
            {!!props.staffs.length && (
                <Row>
                    <div
                        data-color-999
                        data-font-size-14
                        data-margin-right-38
                        style={{
                            flexShrink: 0,
                            marginTop: '26px',
                        }}
                    >
                        收银员
                    </div>
                    <Row
                        style={{
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}
                    >
                        {props.staffs.map(item => (
                            <div
                                className={classnames(cls('tag'), {
                                    [cls('tag', 'active')]: staffSelectAction.has(item),
                                })}
                                key={item.id}
                                onClick={() => {
                                    staffSelectAction.toggle(item)
                                }}
                            >
                                <div hidden={!staffSelectAction.has(item)} className={cls('tag', 'icon')}>
                                    <Iconfont name="iconyixuan" size={14} />
                                </div>
                                <img
                                    alt=""
                                    src={item.user.avatar}
                                    width="24"
                                    height="24"
                                    data-border-radius-50p
                                    data-margin-right-8
                                />
                                <span className={cls('tag', 'nickname')}>{item.user.nickname}</span>
                                {item.user.realname && (
                                    <span className={cls('tag', 'realname')}>({item.user.realname})</span>
                                )}
                            </div>
                        ))}
                    </Row>
                </Row>
            )}
            <div className={cls('bottom')}>
                <div
                    className={cls('bottom', 'reset')}
                    onClick={() => {
                        accountFilterStore.reset()
                    }}
                >
                    重置
                </div>
                <div
                    className={cls('bottom', 'confirm')}
                    onClick={() => {
                        if (!senceSelectAction.select.length) {
                            return $msg('warning', '至少选择一种数据场景')
                        }
                        props.onClose()
                        accountFilterStore.setSatff(staffSelectAction.select)
                        accountFilterStore.setScene(senceSelectAction.select)
                    }}
                >
                    确认
                </div>
            </div>
        </Column>
    )
})

export default AccountFilter
